<!-- eslint-disable no-unused-vars -->
<template>
  <b-card title="" class="text-left">
    <b-form>
      <!-- Projeto -->
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label
              for="projectSelect"
              class="text-center font-weight-bold text-primary"
            >
              Projeto :
            </label>

            <div
              @click="handleShowArquived()"
              :style="{ color: 'blue', padding: '5px 0', cursor: 'pointer' }"
            >
              {{ showArquivded ? 'Ocultar arquivados' : 'Mostrar arquivados' }}
            </div>

            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione um projeto"
              v-model="item.project_id"
              :options="projects"
              label="name"
              :searchable="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Valor -->
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="value" class="text-center font-weight-bold text-primary"
              >Valor :</label
            >

            <b-input-group>
              <BFormInput
                id="value"
                type="text"
                v-model="item.value"
                v-money="moneyMask"
                @change="calcValTax"
              ></BFormInput>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label
              for="value"
              class="text-center font-weight-bold text-primary"
            >
              Impostos:
              <feather-icon
                v-b-tooltip.hover.lefttop.v-primary.html
                :title="`Valor padrão definido em: <br/> Financeiro -> Impostos`"
                icon="InfoIcon"
                size="15"
                style="cursor: pointer"
              />
            </label>
            <b-input-group>
              <BFormInput
                type="number"
                v-model="item.tax"
                min="0"
                max="100"
                step="0.01"
                @input="calcValTax"
              ></BFormInput>
              <b-input-group-append>
                <b-input-group-text>%</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="value" class="text-center font-weight-bold text-primary"
              >Valor deduzido do impostos :</label
            >

            <b-input-group>
              <BFormInput
                id="value_tax"
                type="text"
                v-model="item.value_tax"
                v-money="moneyMask"
                disabled
                @input="calcValTax"
              ></BFormInput>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Data Refrencia -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="date" class="font-weight-bold text-primary"
              >Data de Referência :</label
            >
            <b-form-datepicker
              v-model="item.reference_date"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="pt-br"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Data Transação -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="date" class="font-weight-bold text-primary"
              >Data de Transação :</label
            >

            <b-form-datepicker
              v-model="item.transaction_date"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="pt-br"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Status -->
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="status" class="font-weight-bold text-primary"
              >Status :</label
            >
            <b-form-select
              id="status"
              v-model="item.status"
              :options="statusOptions"
              placeholder="Selecione o status"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Descrição -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="description" class="font-weight-bold text-primary"
              >Descrição :</label
            >
            <BFormTextarea
              id="description"
              type="textarea"
              v-model="item.description"
            ></BFormTextarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Tipo -->
    <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
      <b-col cols="12">
        <b-form-group>
          <label for="status" class="font-weight-bold text-primary"
            >Tipo :</label
          >
          <b-form-select
            id="status"
            v-model="item.type"
            :options="typesOptions"
            placeholder="Selecione o status"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Se Parcelado -->
    <div v-if="item.type == 'parcelado' && item.value">
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <b-input-group prepend="Parcelas">
              <b-form-select
                id="installmentsInput"
                v-model="installmentsInput"
                :options="installmentsOptions"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Parcelas -->
      <div v-if="item.value && installmentsInput > 0">
        <div v-for="(installment, index) in installmentsData" :key="index">
          <b-row
            class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="4">
              <b-form-group>
                <b-input-group prepend="%">
                  <BFormInput
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    v-model="installment.percent"
                    @input="handlePercentChange(index)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="4">
              <b-form-group>
                <b-input-group prepend="R$">
                  <BFormInput
                    type="text"
                    :value="numberToMonetary(installment.value)"
                    @input="updateInstallmentValue(index, $event)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="4">
              <b-form-group>
                <BFormInput
                  type="date"
                  v-model="installment.transaction_date"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-row class="my-1 m-2 pl-2 pr-2 text-right d-flex justify-content-end">
          <b-col cols="12" class="text-right">
            <strong
              >Total parcelado:
              {{ numberToMonetary(totalInstallmentsValue) }}</strong
            >
            <!-- <span
                v-if="Math.abs(installmentsDiff) > 0.01"
                class="text-danger d-block"
              >
                Diferença em relação ao valor esperado:
                {{ numberToMonetary(installmentsDiff) }}
              </span> -->
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="item.type == 'a vista + parcelado' && item.value">
      <b-row
        v-if="item.type == 'a vista + parcelado'"
        class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
      >
        <b-col cols="12">
          <b-form-group>
            <label class="font-weight-bold text-primary">
              Valor à vista :
            </label>

            <b-input-group>
              <BFormInput
                type="text"
                v-model="item.value_cash"
                v-money="moneyMask"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <b-input-group prepend="Parcelas">
              <v-select
                id="installmentsInput"
                v-model="installmentsInput"
                :options="installmentsOptions"
                :reduce="(option) => option.value"
                label="text"
                taggable
                push-tags
                :create-option="
                  (option) => ({
                    value: Number(option),
                    text: `${option}x`,
                  })
                "
                placeholder="Selecione ou digite"
                style="width: 80% !important"
                ;
              >
                <template #prepend> Parcelas </template>
              </v-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Parcelas -->
      <div v-if="item.value && installmentsInput > 0">
        <div v-for="(installment, index) in installmentsData" :key="index">
          <b-row
            class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="4">
              <b-form-group>
                <b-input-group prepend="%">
                  <BFormInput
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    v-model="installment.percent"
                    @input="handlePercentChange(index)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="4">
              <b-form-group>
                <b-input-group prepend="R$">
                  <BFormInput
                    type="text"
                    :value="numberToMonetary(installment.value)"
                    @input="updateInstallmentValue(index, $event)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="4">
              <b-form-group>
                <BFormInput
                  type="date"
                  v-model="installment.transaction_date"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-row class="my-1 m-2 pl-2 pr-2 text-right d-flex justify-content-end">
          <b-col cols="12" class="text-right">
            <strong
              >Total parcelado: R$
              {{ numberToMonetary(totalInstallmentsValue) }}</strong
            >
            <!-- <span
              v-if="Math.abs(installmentsDiff) > 0.01"
              class="text-danger d-block"
            >
              Diferença em relação ao valor esperado: R$
              {{ numberToMonetary(installmentsDiff) }}
            </span> -->
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Se Repetir -->

    <!-- Botoes -->
    <div class="justify-center">
      <BButton variant="outline" @click="closeModal">Voltar</BButton>
      <BButton variant="primary" @click="saveItem">Salvar</BButton>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BCol,
  BRow,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText,
  BFormDatepicker,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { VBTooltip } from 'bootstrap-vue';
import moment from 'moment';

export default {
  name: 'revenue-add',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BFormInput,
    BCol,
    BRow,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
    BFormDatepicker,
  },
  data: () => ({
    lastInstallmentsInput: null,
    compKey: 0,
    created_by: '',
    installmentsData: [],
    installmentsOptions: Array.from({ length: 36 }, (_, i) => ({
      value: i + 1,
      text: `${i + 1}x`,
    })),
    item: {
      project_id: null,
      type: 'a vista',
      status: 'previsto',
      value: 0,
      value_cash: 0,
      value_tax: 0,
      repeat: 0,
      tax: 0,
      tax_description: '',
      transaction_date: moment().format('YYYY-MM-DD'),
      reference_date: moment().format('YYYY-MM-DD'),
      original_value: '',
    },
    moneyMask: {
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      decimal: ',',
      precision: 2,
      masked: false,
    },
    installments: [],
    projects: [],
    installmentsInput: null,
    statusOptions: ['previsto', 'realizado'],
    typesOptions: ['a vista', 'a vista + parcelado', 'parcelado'],
    showArquivded: false,
    instalment_date_increase: moment().format('YYYY-MM-DD'),
  }),

  mounted() {
    this.getProjects();
    this.getTax();
    this.getMemberId();
  },
  watch: {
    item: {
      handler() {
        // Só chama se o valor total for > 0 e houver parcelas
        if (
          this.installmentsInput > 0 &&
          this.monetaryToNumber(this.item.value) > 0
        ) {
          this.buildInstallmentsData();
        }
      },
      deep: true,
    },
    installmentsInput: {
      immediate: true,
      handler(val, oldVal) {
        this.buildInstallmentsData(val !== oldVal);
      },
    },

    'item.value': {
      immediate: false,
      handler() {
        this.buildInstallmentsData();
        this.calcValTax();
      },
    },

    'item.value_cash': {
      immediate: false,
      handler() {
        if (this.item.type === 'a vista + parcelado') {
          this.buildInstallmentsData();
        }
      },
    },

    'item.type': {
      immediate: false,
      handler() {
        this.buildInstallmentsData();
      },
    },
  },

  computed: {
    currentUser() {
      return this.$store.getters.user.accesses.find(
        (a) => a.workspace_id == this.$store.getters.currentWorkspace.id,
      );
    }, // Soma bruta das parcelas atuais
    totalInstallmentsValue() {
      return this.installmentsData.reduce(
        (acc, installment) => acc + (Number(installment.value) || 0),
        0,
      );
    },

    // Valor total que as parcelas deveriam somar (considerando "a vista + parcelado")
    expectedInstallmentsTotal() {
      let totalValue = this.monetaryToNumber(this.item.value) || 0;

      if (this.item.type === 'a vista + parcelado') {
        const cashValue = this.monetaryToNumber(this.item.value_cash) || 0;
        totalValue -= cashValue;
        if (totalValue < 0) totalValue = 0;
      }

      return totalValue;
    },

    // Diferença entre o que foi somado e o esperado (ideal: 0)
    installmentsDiff() {
      return Number(
        (this.expectedInstallmentsTotal - this.totalInstallmentsValue).toFixed(
          2,
        ),
      );
    },
  },

  methods: {
    updateInstallmentValue(index, rawValue) {
      // Converte o que veio do input (ex: "1.234,56") para número
      const numericValue = this.monetaryToNumber(rawValue);
      if (!isNaN(numericValue) && numericValue >= 0) {
        this.installmentsData[index].value = numericValue;
        this.handleValueChange(index);
      }
    },
    buildInstallmentsData(forceResetPercent = false) {
      const totalInstallments = parseInt(this.installmentsInput) || 0;

      let totalValue = this.monetaryToNumber(this.item.value) || 0;

      // subtrai valor à vista SEM alterar o item.value
      if (this.item.type === 'a vista + parcelado') {
        const cashValue = this.monetaryToNumber(this.item.value_cash) || 0;

        totalValue -= cashValue;

        if (totalValue < 0) {
          totalValue = 0;
        }
      }

      if (!totalInstallments || !totalValue) {
        this.installmentsData = [];
        return;
      }

      const current = [...this.installmentsData];

      //const defaultPercent = Number((100 / totalInstallments).toFixed(2));

      const installmentValue = Number(
        (totalValue / totalInstallments).toFixed(2),
      );

      let accumulated = 0;

      this.installmentsData = Array.from(
        { length: totalInstallments },
        (_, index) => {
          const existing = current[index];

          let value = installmentValue;

          // última parcela recebe ajuste
          if (index === totalInstallments - 1) {
            value = Number((totalValue - accumulated).toFixed(2));
          } else {
            accumulated += installmentValue;
          }

          return {
            percent: forceResetPercent
              ? Number((100 / totalInstallments).toFixed(2))
              : existing?.percent ??
                Number((100 / totalInstallments).toFixed(2)),

            value: forceResetPercent ? value : existing?.value ?? value,

            transaction_date:
              existing?.transaction_date || this.installmentIncrease(index),
          };
        },
      );

      this.recalculateInstallmentValues();
    },

    recalculateInstallmentValues() {
      let totalValue = this.monetaryToNumber(this.item.value) || 0;

      if (this.item.type === 'a vista + parcelado') {
        const cashValue = this.monetaryToNumber(this.item.value_cash) || 0;

        totalValue -= cashValue;

        if (totalValue < 0) {
          totalValue = 0;
        }
      }

      let accumulated = 0;

      this.installmentsData = this.installmentsData.map(
        (installment, index) => {
          let calculatedValue = Number(
            ((totalValue * Number(installment.percent || 0)) / 100).toFixed(2),
          );

          // ajusta última parcela
          if (index === this.installmentsData.length - 1) {
            calculatedValue = Number((totalValue - accumulated).toFixed(2));
          } else {
            accumulated += calculatedValue;
          }

          return {
            ...installment,
            value: calculatedValue,
          };
        },
      );
    },
    handlePercentChange(index) {
      let totalValue = this.monetaryToNumber(this.item.value) || 0;

      if (this.item.type === 'a vista + parcelado') {
        const cashValue = this.monetaryToNumber(this.item.value_cash) || 0;

        totalValue -= cashValue;

        if (totalValue < 0) {
          totalValue = 0;
        }
      }

      const percent = Number(this.installmentsData[index].percent || 0);

      this.installmentsData[index].value = Number(
        ((totalValue * percent) / 100).toFixed(2),
      );
    },
    handleValueChange(index) {
      let totalValue = this.monetaryToNumber(this.item.value) || 0;
      if (this.item.type === 'a vista + parcelado') {
        const cashValue = this.monetaryToNumber(this.item.value_cash) || 0;
        totalValue -= cashValue;
        if (totalValue < 0) totalValue = 0;
      }

      const currentValue = this.installmentsData[index].value; // já é número
      if (!totalValue || totalValue === 0) {
        this.installmentsData[index].percent = 0;
        return;
      }
      this.installmentsData[index].percent = Number(
        ((currentValue / totalValue) * 100).toFixed(2),
      );
    },
    async getMemberId() {
      await this.$store
        .dispatch('getUserMember', {
          id: this.currentUser.user_id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          console.log('membro ', resp);
          this.created_by = resp[0].member_id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTax() {
      this.$store
        .dispatch('getTax', {
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          if (resp) {
            this.item.tax = (resp.tax_percentage / 100).toFixed(2);
            this.item.tax_description = resp.tax_name;
          } else {
            this.item.tax = 0;
            this.item.tax_description = 'Não configurado.';
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calcValTax() {
      let val = this.monetaryToNumber(this.item.value);
      this.item.value_tax = this.numberToMonetary(
        (1 - this.item.tax / 100) * val,
      );
    },

    async getProjects() {
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        page: 1,
        perPage: 1000,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          resp.data.map((e) => {
            if (this.showArquivded) {
              this.projects.push({
                id: e.id,
                name: `${e.project_code} - ${e.project_name} ${
                  e.is_archived ? '(Arquivado)' : ''
                }`,
              });
            } else {
              if (e.is_archived) {
                return null;
              } else {
                this.projects.push({
                  id: e.id,
                  name: `${e.project_code} - ${e.project_name} ${
                    e.is_archived ? '(Arquivado)' : ''
                  }`,
                });
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async saveItem() {
      this.installments = [];

      if (
        (this.item.type === 'parcelado' ||
          this.item.type === 'a vista + parcelado') &&
        this.installmentsInput > 0
      ) {
        this.installments = this.installmentsData.map((installment) => ({
          value:
            typeof installment.value === 'string'
              ? this.monetaryOnlyCommas(installment.value)
              : installment.value,
          transaction_date: installment.transaction_date,
        }));
      }

      const payload = {
        ...this.item,
        description: this.item.description
          ? this.item.description
          : 'Sem descrição',
        value:
          this.item.type === 'a vista + parcelado'
            ? this.monetaryToNumber(this.item.value) -
              (this.monetaryToNumber(this.item.value_cash) || 0)
            : this.monetaryToNumber(this.item.value),
        value_cash: this.item.value_cash
          ? this.monetaryToNumber(this.item.value_cash)
          : 0,
        value_tax: parseInt(
          this.item.value_tax.toString().replace(/\./g, '').replace(/,/g, ''),
        ),
        project_id: this.item.project_id.id,
        project_name: this.item.project_id.name,
        installments: this.installments,
        workspace_id: this.$store.getters.currentWorkspace.id,
        created_by: this.created_by,
      };

      this.$store
        .dispatch('saveRevenue', payload)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Receita criada com sucesso.',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          });

          this.$emit('getAll');

          if (this.$route.name === 'nova-receita') {
            this.$router.go(-1);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao criar receita.',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },
    closeModal() {
      //this.$router.push('/lancamento-de-receita');

      this.$emit('closeModal');
    },

    installmentIncrease(i) {
      let installmentDate = moment();
      installmentDate.add(i + 1, 'months');

      return installmentDate.format('YYYY-MM-DD');
    },

    async createInstallmentsLength() {
      if (this.installments.length < this.installmentsInput) {
        for (
          let i = this.installments.length;
          i < this.installmentsInput;
          i++
        ) {
          this.installments.push({ value: 0 });
        }
      } else if (
        this.installments.length > this.installmentsInput &&
        this.installmentsInput !== 0
      ) {
        for (
          let i = this.installments.length - 1;
          i >= this.installmentsInput;
          i--
        ) {
          console.log('minus');
          this.installments.pop();
        }
      }

      console.log(this.installments);
    },

    handleShowArquived() {
      this.showArquivded = !this.showArquivded;
      this.projects = [];
      this.getProjects();
    },
  },
};
</script>
<style>
.justify-center {
  display: flex;
  justify-content: center;
}
td::before {
  float: none !important;
}
</style>
